export default __webpack_public_path__ + "static/media/mms-new-logo.e766b45b.png";